import React from 'react';
import { noop } from 'common/constants/constants';

interface SelectedUsersContextType {
  selectedUsers: number[];
  setSelectedUsers: (user: number[]) => void;
}

interface EditUserContextType {
  editUser: boolean;
  setEditUser: (isEdit: boolean) => void;
}

export const SelectedUsersContext = React.createContext({
  selectedUsers: [],
  setSelectedUsers: noop,
} as SelectedUsersContextType);

export const EditUserContext = React.createContext({
  editUser: false,
  setEditUser: noop,
} as EditUserContextType);
